import React, { ReactNode } from 'react';

import Classes from './HorizontalScrollList.module.scss';

type TProps = {
  children: ReactNode;
  className?: string;
};

const HorizontalScrollListItem = ({ children, className }: TProps) => (
  <div className={`${Classes.listItem} ${className}`}>{children}</div>
);

export default HorizontalScrollListItem;
